import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
// import { Staff } from "./staff.model";
import { Employee } from "./employee.model";
import { Commonmaster } from "../../commonmasters/commonmaster.model";
import { DatePipe } from "@angular/common"


@Injectable({
  providedIn: 'root'
})

export class StaffService {

  selectedEmployee: Employee;
  EmployeeList: Employee[];

  selectedCommonmaster : Commonmaster;
  commonMastersList :Commonmaster[];

  id :number;

  constructor(private httpClient: HttpClient,private datePipe: DatePipe) { }

  getBaseUrl() {  
    return environment.baseUrl;
  }  

  FetchStaffbyId(employee: Employee) {
    var body = employee;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Staff/Fetch', body, { headers: headers });
  }

  IUDStaff(employee: Employee) {

    console.log(employee);
    // staff.FromDate =new Date( Date.parse( this.datePipe.transform( staff.FromDate,"yyyy-MM-dd")));
    // staff.ToDate =new Date( Date.parse( this.datePipe.transform( staff.ToDate,"yyyy-MM-dd")));
    this.selectedEmployee.Salutation = employee.Salutation;
    this.selectedEmployee.DOB = employee.DOB;
    this.selectedEmployee.JoiningDate = employee.JoiningDate;
    this.selectedEmployee.TerminationDate = employee.TerminationDate;
    this.selectedEmployee.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedEmployee.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    // this.selectedEmployee.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedEmployee.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedEmployee;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Staff/IUD', body, { headers: headers });
  }

  
  IUDStaffMaster(employee: Employee) {

    console.log(employee);
    // staff.FromDate =new Date( Date.parse( this.datePipe.transform( staff.FromDate,"yyyy-MM-dd")));
    // staff.ToDate =new Date( Date.parse( this.datePipe.transform( staff.ToDate,"yyyy-MM-dd")));

    this.selectedEmployee = new Employee;
    this.selectedEmployee.Code = employee.Code;
    this.selectedEmployee.Id = employee.Id;
    this.selectedEmployee.UserName = employee.UserName;
    this.selectedEmployee.Password = employee.Password;
    this.selectedEmployee.RoleId = employee.RoleId;
    this.selectedEmployee.IsStaffMaster = 1;
    this.selectedEmployee.Flag = 2; // IUDEmployeeMaster

    this.selectedEmployee.TerminationDate = employee.TerminationDate;
    
    this.selectedEmployee.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedEmployee.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    // this.selectedEmployee.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedEmployee.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedEmployee;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Staff/IUD', body, { headers: headers });
     // need to change Employee Management SP
  }

  FetchStaff() {
    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Staff/Fetch', body, { headers: headers });

   }

  FetchStaffList() {
    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Staff/FetchList', body, { headers: headers });

  }

  IUDStaffFiles(formData:FormData) {

    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Staff/IUDFiles', formData, 
    {
      reportProgress: true,
      observe: 'events'
    });
  }
}
